<div class="boundary-condition-form-field">
    <dx-select-box [items]="options"
    [(value)]="option"
    (onValueChanged)="valueChanged()"
    width="500"></dx-select-box>
  </div>

  <lib-number-field
    [quantity]="quantity.PRESSURE"
    [visible]="
    option == setUpstreamPressureandDownstreamPressure
     || option == setUpstreamPressureandThroughput
     || option == setUpstreamPressureandDownstreamSpeed"
    [label]="labels[keys.systemUpstreamPressure]"
    [(value)]="upstreamPressure"
    (valueChange)="upstreamPressure=$event;valueChanged()"
    [error] = "errors[keys.systemUpstreamPressure]"
    >
  </lib-number-field>

  <lib-number-field
  [quantity]="quantity.PRESSURE"
  [visible]="option == setUpstreamPressureandDownstreamPressure
   || option == setDownstreamPressureandDownstreamSpeed
   || option == setDownstreamPressureandThroughput"
    [label]="labels[keys.systemDownstreamPressure]"
    [(value)]="downstreamPressure"
    (valueChange)="downstreamPressure=$event;valueChanged()"
    [error]="errors[keys.systemDownstreamPressure]"
    >
  </lib-number-field>

  <lib-number-field
  [quantity]="quantity.SPEED"
  [visible]="option == setUpstreamPressureandDownstreamSpeed
   || option == setDownstreamPressureandDownstreamSpeed"
  [label]="labels[keys.systemDownstreamSpeed]"
  [(value)]="downstreamSpeed"
  (valueChange)="downstreamSpeed=$event;valueChanged()"
  [error]="errors[keys.systemDownstreamSpeed]"
  >
  </lib-number-field>

  <lib-number-field
  [quantity]="quantity.THROUGHPUT"
  [visible]="option == setUpstreamPressureandThroughput
   || option == setDownstreamPressureandThroughput"
  [label]="labels[keys.systemThroughput]"
  [(value)]="throughput"
  (valueChange)="throughput=$event;valueChanged()"
  [error]="errors[keys.systemThroughput]"
  [offerQuantitySelectionForThroughput]="true"
  (valueChangeWithQuantity)="throughput=$event.value;throughPutQuantityChange($event);"
  >
  </lib-number-field>
